import { createAsyncThunk } from '@reduxjs/toolkit'
import { BrokerInfo } from './reducer'
import { getBrokerPrice } from '../../api/v1/broker'
import { improveDecimals } from '../../utils/decimals'
import { bn } from '../../utils/number'
import toastify from '../../components/Toastify'
import { L1ChainId, TokenId } from '../../types'

export const fetchBrokerInfoAction = createAsyncThunk<
  BrokerInfo,
  {
    chainId: L1ChainId
    tokenId: TokenId
    decimals: number
  }
>('broker/fetchBrokerInfoAction', async ({ chainId, tokenId, decimals }) => {
  const response = await getBrokerPrice(chainId, tokenId).catch((e) => {
    toastify.warn('Failed to get broker price, please try again later.')
    throw e
  })

  const { available = '0', fee = 0, limit = '0' } = response

  return {
    available: improveDecimals(bn(available), decimals).toString(),
    fee,
    limit: improveDecimals(bn(limit), decimals).toString(),
  }
})
